import { render, staticRenderFns } from "./AppDonutCard.vue?vue&type=template&id=20e4dd9c"
import script from "./AppDonutCard.vue?vue&type=script&lang=js"
export * from "./AppDonutCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports